import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {GroupContainerModel} from '../../../../../models/aggregates/group';
import {Core2Config} from '../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class GroupService extends BaseApiTemplateService<GroupContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'groups';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'groups';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'groups';
    this.httpClient = http;
  }
}
